class HomeProblemV2 extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        if (window.innerWidth > 767) {
            this.setup()
        } else {
            this.setupMobile()
        }
    }
    setupMobile() {
        this.querySelector('.home-prob-content-inner').classList.add('swiper');
        this.querySelector('.home-prob-content-body-list').classList.add('swiper-wrapper');
        this.querySelectorAll('.home-prob-content-body-item').forEach((item) => {
            item.classList.add('swiper-slide');
        });
        const imgList = this.querySelectorAll('.home-prob-content-body-img-item');
        const homeProbSwiper = new Swiper(this.querySelector('.home-prob-content-inner'), {
            modules: [Pagination],
            slidesPerView: 1,
            spaceBetween: parseRem(10),
            loop: true,
            pagination: {
                el: this.querySelector('.home-prob-content-body-pagi'),
                bulletClass: 'home-prob-content-body-pagi-item',
                bulletActiveClass: 'is-active',
                clickable: true,
            },
        });
        homeProbSwiper.on('slideChange', () => {
            imgList.forEach((item) => {
                item.classList.remove('active');
            });
            imgList[homeProbSwiper.realIndex].classList.add('active');
        });
    }
    setup() {
        const listTitles = this.querySelectorAll('.home-prob-content-body-item-content');
        const listGrpsImage = this.querySelectorAll('.home-prob-image-item');
        const imageWrap = this.querySelector('.home-prob-image-wrap');

        this.listTitles = listTitles;
        this.listGrpsImage = listGrpsImage;
        this.imageWrap = imageWrap;

        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.home-prob-content'), start: `top ${getScreenType().isDesktop ? 70 : 90}%`},
            tweenArr: [
                new FadeIn({ el: this.querySelector('.home-prob-content') }),
                new FadeIn({ el: this.querySelector('.home-prob-content-ic')}),
                new RevealText({ el: this.querySelector(`.home-prob-content-label-${window.innerWidth > 991 ? 'dk' : 'mb'} .txt`), color: "rgba(29, 29, 29, 0.80)", isFast: true })
            ]
        })

        this.setupText();

        gsap.timeline({
            scrollTrigger: {
                trigger: this.querySelector('.home-prob-content'),
                start: `top ${getScreenType().isDesktop ? 70 : 90}%`,
                scrub: false,
                once: true,
                onEnter: () => {
                    setTimeout(() => this.interact(), 400);
                }
            },
        });
    }

    interact() {
        let stepCurrent = 0;
        const target = this.querySelector('.home-prob');
        const progressItem = this.querySelector('.home-prob-content-progress');
        let tl;

        const progress = (target, stepCurrent = 0) => {
            if(tl) tl.kill();
            tl = gsap.timeline();
            tl.to(target,
                {
                    "--progress-percent": 100,
                    ease: "power1.inOut",
                    duration: 5,
                    onStart: () => {
                        progressItem.classList.remove('is-rotate');
                        this.activeIndex(stepCurrent);
                    }
                }
            );

            tl.to(target, {
                "--progress-percent": 0,
                duration: 0.6,
                ease: "power1.out",
                onStart: () => {
                    progressItem.classList.add('is-rotate');
                },
                onComplete: () => {
                    stepCurrent = stepCurrent >= this.listTitles.length - 1 ? 0 : stepCurrent + 1;
                    setTimeout(() => {
                        progress(target, stepCurrent);
                    },500)
                }
            });
        };

        progress(target, stepCurrent);
        this.activeIndex(stepCurrent)
    }
    setupText() {
        this.listTitles.forEach((title) => {
            const titleSplit = new TextSplit({ el: title.querySelector('.txt'), type: 'words' });
                titleSplit.DOM.splitType?.words.forEach((word, idx) => {
                    gsap.set(word, { '--trans-delay': `${(idx + 1) * .04}s` })
            })
        });
    }
    activeIndex(index) {
        this.listTitles.forEach((item) => {
            item.classList.remove('active')
        })
        this.listGrpsImage.forEach((item) => {
            item.classList.remove('active')
        })

        if (index >= 0) {
            this.listTitles[index].classList.add('active')
            this.listGrpsImage[index].classList.add('active')
        }
    }
}

customElements.define('home-prob', HomeProblemV2);
